export const TYPE_VIDEO = "video"
export const TYPE_IMAGE = "image"

export default {
    methods: {
        isVideo(media) {
            if (!media) return false
            return (
                media.type === TYPE_VIDEO ||
                !!media.isVideo ||
                media.vimeo_id !== undefined ||
                !!media.type?.startsWith("video")
            )
        },
        isVideoDisplayable(media) {
            if (!this.isVideo(media)) return false
            return media.is_rendered || !!media.local
        },
        isImage(media) {
            if (!media) return false
            return (
                !this.isVideo(media) &&
                (media.type === TYPE_IMAGE ||
                    !!media.type?.startsWith("image") ||
                    !!media.file_path?.includes("images"))
            )
        },
        getMediaKey(media, prefix = "") {
            const mediaType = this.isVideo(media) ? "video" : "image"
            const id = media?.uid || media?.id
            return `${prefix}${mediaType}-${id}`
        },
    },
}
